import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBaseFiltersApiResponse} from 'models/filters-selections';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchFutureProgramYearsThunk: any = createAsyncThunk<IBaseFiltersApiResponse, null>(
  `${prefix} fetchFutureProgramYears`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getFutureProgramYears();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch program. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
